import React, { useCallback, useEffect, useState } from 'react';
import api from '../services/api';
import useToast from '../hooks/useToast';
import ToastContainer from '../components/ToastContainer';

const ZimmetRaporlariPage = () => {
  const [stats, setStats] = useState({
    total: 0,
    active: 0,
    maintenance: 0,
    inactive: 0,
    categoryStats: [],
    departmentStats: []
  });
  const [loading, setLoading] = useState(true);
  const { toasts, addToast, removeToast } = useToast();

  const fetchStats = useCallback(async () => {
    try {
      setLoading(true);
      const response = await api.getInventoryStats();
      if (response.success && response.data) {
        setStats(response.data);
      }
    } catch (error) {
      console.error('İstatistikler yüklenirken hata:', error);
      addToast('İstatistikler yüklenirken bir hata oluştu', 'error', 5000);
    } finally {
      setLoading(false);
    }
  }, [addToast]);

  useEffect(() => {
    fetchStats();
  }, [fetchStats]);

  const handleDownloadReport = (type) => {
    addToast(`${type} raporu indiriliyor...`, 'info', 3000);
    // Burada gerçek rapor indirme işlemi yapılabilir
  };

  return (
    <div className="modern-hr-page">
      <div className="container-fluid">
        <div className="modern-hr-header">
          <div className="modern-hr-header-content">
            <div className="modern-hr-header-text">
              <h1>Zimmet Raporları</h1>
              <p>Zimmet istatistikleri ve analiz raporları</p>
            </div>
            <div className="modern-hr-header-actions">
              <div className="modern-hr-stats">
                <div className="modern-hr-stat-item">
                  <i className="bx bx-bar-chart"></i>
                  <span>Raporlar</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Genel İstatistikler */}
        <div className="row mb-4">
          <div className="col-lg-3 col-md-6 mb-3">
            <div className="modern-stats-card">
              <div className="modern-stats-card-icon bg-primary">
                <i className="bx bx-package"></i>
              </div>
              <div className="modern-stats-card-content">
                <h3>{stats.total}</h3>
                <p>Toplam Zimmet</p>
              </div>
            </div>
          </div>
          <div className="col-lg-3 col-md-6 mb-3">
            <div className="modern-stats-card">
              <div className="modern-stats-card-icon bg-success">
                <i className="bx bx-check-circle"></i>
              </div>
              <div className="modern-stats-card-content">
                <h3>{stats.active}</h3>
                <p>Aktif</p>
              </div>
            </div>
          </div>
          <div className="col-lg-3 col-md-6 mb-3">
            <div className="modern-stats-card">
              <div className="modern-stats-card-icon bg-warning">
                <i className="bx bx-wrench"></i>
              </div>
              <div className="modern-stats-card-content">
                <h3>{stats.maintenance}</h3>
                <p>Bakımda</p>
              </div>
            </div>
          </div>
          <div className="col-lg-3 col-md-6 mb-3">
            <div className="modern-stats-card">
              <div className="modern-stats-card-icon bg-danger">
                <i className="bx bx-x-circle"></i>
              </div>
              <div className="modern-stats-card-content">
                <h3>{stats.inactive}</h3>
                <p>Pasif</p>
              </div>
            </div>
          </div>
        </div>

        <div className="row">
          {/* Kategori Dağılımı */}
          <div className="col-lg-6 col-md-12 mb-4">
            <div className="modern-hr-widget">
              <div className="modern-hr-widget-header">
                <div className="modern-hr-widget-title">
                  <i className="bx bx-category"></i>
                  <h4>Kategori Dağılımı</h4>
                </div>
              </div>
              <div className="modern-hr-widget-body">
                {loading ? (
                  <div className="text-center py-3">
                    <div className="spinner-border text-primary" role="status">
                      <span className="visually-hidden">Yükleniyor...</span>
                    </div>
                  </div>
                ) : (
                  <div className="modern-stats-list">
                    {stats.categoryStats && stats.categoryStats.map((item, index) => (
                      <div key={index} className="modern-stats-item">
                        <div className="modern-stats-item-info">
                          <span className="modern-stats-item-label">{item._id}</span>
                          <span className="modern-stats-item-value">{item.count}</span>
                        </div>
                        <div className="modern-stats-item-bar">
                          <div 
                            className="modern-stats-item-progress bg-primary" 
                            style={{ width: `${stats.total > 0 ? Math.round((item.count / stats.total) * 100) : 0}%` }}
                          ></div>
                        </div>
                      </div>
                    ))}
                  </div>
                )}
              </div>
            </div>
          </div>

          {/* Departman Dağılımı */}
          <div className="col-lg-6 col-md-12 mb-4">
            <div className="modern-hr-widget">
              <div className="modern-hr-widget-header">
                <div className="modern-hr-widget-title">
                  <i className="bx bx-building"></i>
                  <h4>Departman Dağılımı</h4>
                </div>
              </div>
              <div className="modern-hr-widget-body">
                {loading ? (
                  <div className="text-center py-3">
                    <div className="spinner-border text-primary" role="status">
                      <span className="visually-hidden">Yükleniyor...</span>
                    </div>
                  </div>
                ) : (
                  <div className="modern-stats-list">
                    {stats.departmentStats && stats.departmentStats.map((item, index) => (
                      <div key={index} className="modern-stats-item">
                        <div className="modern-stats-item-info">
                          <span className="modern-stats-item-label">{item._id}</span>
                          <span className="modern-stats-item-value">{item.count}</span>
                        </div>
                        <div className="modern-stats-item-bar">
                          <div 
                            className="modern-stats-item-progress bg-info" 
                            style={{ width: `${stats.total > 0 ? Math.round((item.count / stats.total) * 100) : 0}%` }}
                          ></div>
                        </div>
                      </div>
                    ))}
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>

        {/* Rapor İndirme */}
        <div className="modern-hr-widget">
          <div className="modern-hr-widget-header">
            <div className="modern-hr-widget-title">
              <i className="bx bx-download"></i>
              <h4>Rapor İndirme</h4>
            </div>
          </div>
          <div className="modern-hr-widget-body">
            <div className="row">
              <div className="col-md-4 mb-3">
                <div className="modern-report-card">
                  <div className="modern-report-card-icon bg-primary">
                    <i className="bx bx-download"></i>
                  </div>
                  <div className="modern-report-card-content">
                    <h6>Departman Bazlı Rapor</h6>
                    <p>Zimmet dağılımını departmanlara göre görüntüleyin</p>
                    <button 
                      className="modern-hr-btn modern-hr-btn-outline modern-hr-btn-sm"
                      onClick={() => handleDownloadReport('Departman Bazlı')}
                    >
                      <i className="bx bx-download"></i>
                      İndir
                    </button>
                  </div>
                </div>
              </div>
              <div className="col-md-4 mb-3">
                <div className="modern-report-card">
                  <div className="modern-report-card-icon bg-success">
                    <i className="bx bx-download"></i>
                  </div>
                  <div className="modern-report-card-content">
                    <h6>Kategori Bazlı Rapor</h6>
                    <p>Zimmet dağılımını kategorilere göre görüntüleyin</p>
                    <button 
                      className="modern-hr-btn modern-hr-btn-outline modern-hr-btn-sm"
                      onClick={() => handleDownloadReport('Kategori Bazlı')}
                    >
                      <i className="bx bx-download"></i>
                      İndir
                    </button>
                  </div>
                </div>
              </div>
              <div className="col-md-4 mb-3">
                <div className="modern-report-card">
                  <div className="modern-report-card-icon bg-info">
                    <i className="bx bx-download"></i>
                  </div>
                  <div className="modern-report-card-content">
                    <h6>Lokasyon Bazlı Rapor</h6>
                    <p>Zimmet dağılımını lokasyonlara göre görüntüleyin</p>
                    <button 
                      className="modern-hr-btn modern-hr-btn-outline modern-hr-btn-sm"
                      onClick={() => handleDownloadReport('Lokasyon Bazlı')}
                    >
                      <i className="bx bx-download"></i>
                      İndir
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <ToastContainer toasts={toasts} removeToast={removeToast} />
    </div>
  );
};

export default ZimmetRaporlariPage;
